<template>
  <select class="form-control border-radius-4px" @change="update">
    <option value="after" :selected="after">{{$t('client.after')}}</option>
    <option value="before" :selected="before">{{$t('client.before')}}</option>
  </select>
</template>

<script>
  export default {
    name: 'SelectPosition',
    props: {
      value: {
        type: Object,
        default: {}
      }
    },
    components: {
    },
    data: function () {
      return {
        after: false,
        before: true
      }
    },
    methods: {
      update (event) {
        if (event.target.value == 'after') {
          this.after = true
          this.before = false
        } else {
          this.after = false
          this.before = true
        }
        let data = this._.cloneDeep(this.value)
        data.after = this.after
        data.before = this.before
        this.$emit('input', data)
      }
    },
    created: function () {
      if (this.value.after != null) {
        this.after = this.value.after
      }
      if (this.value.before != null) {
        this.before = this.value.before
      }
    },
    mounted: function () {
    },
    watch: {
      after: {
        handler: function (newValue) {
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/SelectPosition.vue